/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Export_BusyInputs */

const en_us2_profile_editors_export_busy = /** @type {(inputs: Profile_Editors_Export_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Building the file…`)
};

const pt_br2_profile_editors_export_busy = /** @type {(inputs: Profile_Editors_Export_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montando o arquivo…`)
};

const es_419_profile_editors_export_busy = /** @type {(inputs: Profile_Editors_Export_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armando el archivo…`)
};

const pt_pt2_profile_editors_export_busy = /** @type {(inputs: Profile_Editors_Export_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A preparar o ficheiro…`)
};

const fr_fr2_profile_editors_export_busy = /** @type {(inputs: Profile_Editors_Export_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Création du fichier…`)
};

const de_de2_profile_editors_export_busy = /** @type {(inputs: Profile_Editors_Export_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei wird erstellt…`)
};

const it_it2_profile_editors_export_busy = /** @type {(inputs: Profile_Editors_Export_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparo il file…`)
};

/**
* | output |
* | --- |
* | "Building the file…" |
*
* @param {Profile_Editors_Export_BusyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_export_busy = /** @type {((inputs?: Profile_Editors_Export_BusyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Export_BusyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_export_busy(inputs)
	if (locale === "es-419") return es_419_profile_editors_export_busy(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_export_busy(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_export_busy(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_export_busy(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_export_busy(inputs)
	return en_us2_profile_editors_export_busy(inputs)
});
export { profile_editors_export_busy as "profile-editors.export_busy" }